import { BRAND_PRODUCTS } from "../../data/brandCatalogue.generated";

export type { Product } from "../../data/productTypes";

/**
 * The active brand's catalogue (src/data/products.json filtered by brand.productIds),
 * generated by scripts/apply-brand.js so other brands' products never ship in the bundle.
 */
const products = BRAND_PRODUCTS;

export default products;
